import React from 'react';
import {productsAPI} from "../api/api";
import ShowNotification from "../components/common/Notification/ShowNotification";

const SET_PRODUCT_DATA = 'SET_PRODUCT_DATA';
export const setProductData = (payload) => {
    return {
        type: SET_PRODUCT_DATA,
        payload: payload
    }
}



let initialState = {
    products:[
        {
            "id": 1,
            "title": "title 3",
            "content": "content 3",
            "imgUrl": "100",
            "youtubeLink": "1010",
            "status": 1,
            "productType": 1,
            "price": "1500.00",
            "a": null,
            "b": null,
            "startDate": "2021-06-28 14:00:00",
            "endDate": "2021-08-28 18:00:00",
            "created_at": "2021-07-21T15:48:51.000000Z",
            "updated_at": "2021-07-21T15:48:51.000000Z"
        }
    ],
    totalPages:4,
    totalElements:31,
    size:10
}

let productReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PRODUCT_DATA:
            return {
                ...state,
                products:action.payload.products,
                totalPages: action.payload.totalPages,
                totalElements: action.payload.totalElements,
                size: action.payload.size,
            }

        default :
            return state;
    }
}


export const getProductsTh = (page,size) => {
    return async (dispatch) => {
        let response = await productsAPI.getProducts(page,size );
        debugger
        if (response) {
            dispatch(setProductData(response));
        }else {
            let errorMessage='Server: '+response.response.data;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const addProductTh = (product) => {
    return async (dispatch) => {
        let response = await productsAPI.addProduct(product);
        debugger
        if (response.status===201) {
            debugger
            ShowNotification("Succes","Product added successful", "success")
            dispatch(getProductsTh(0,10));
        } else {
            let errorMessage='Server: '+response.response.data;
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const updateProductTh = (product) => {
    return async (dispatch) => {
        let response = await productsAPI.editProduct(product);

        if (response && response.status === 200) {
            ShowNotification("Succes","Product updated successful", "warning")
            dispatch(getProductsTh(0,10));
        } else {
            let errorMessage='Server: '+(response?.data?.message || 'Unknown error');
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export const deleteProductTh = (productId) => {
    return async (dispatch) => {
        let response = await productsAPI.deleteProduct(productId );
        if (response && response.status === 200) {
            // Soft delete — məhsul status=0 olur, siyahıdan silinmir
            ShowNotification("Succes","Product deactivated successful", "danger")
            dispatch(getProductsTh(0,10));
        }else {
            let errorMessage='Server: '+(response?.data?.message || 'Unknown error');
            ShowNotification("Error",errorMessage,"danger",3000)
        }
    }
}
export default productReducer;
